import React, { useEffect, useState } from "react";
import { Container, Table, Button, Modal, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { AdminUserService } from "../services/AdminUserService";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function AdminUsers() {
    const navigate = useNavigate();
    const adminUser = JSON.parse(localStorage.getItem("adminUser"));

    const [users, setUsers] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [editingUser, setEditingUser] = useState(null);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [role, setRole] = useState("Admin");
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const adminUser = JSON.parse(localStorage.getItem("adminUser"));
        if (!adminUser || adminUser.role !== "SuperAdmin") {
            navigate("/dashboard");
        }
        loadUsers();
    }, []);

    const handleLogout = () => {

        localStorage.removeItem("adminToken");
        localStorage.removeItem("adminUser");

        navigate("/");

    };

    const loadUsers = async () => {

        const res = await AdminUserService.getUsers();
        setUsers(res);

    };

    const handleAddAdmin = () => {

        setEditingUser(null);
        setName("");
        setEmail("");
        setPassword("");
        setRole("Admin");
        setShowModal(true);
        setErrors({});

    };

    const openEdit = (user) => {

        setEditingUser(user);
        setName(user.name);
        setEmail(user.email);
        setRole(user.role);
        setPassword("");
        setShowModal(true);
        setErrors({});

    };

    const validate = () => {

        const newErrors = {};

        if (!name.trim()) {
            newErrors.name = "Name is required";
        }

        if (!email.trim()) {
            newErrors.email = "Email is required";
        }

        if (!role) {
            newErrors.role = "Role is required";
        }

        if (!editingUser) {

            if (!password) {
                newErrors.password = "Password is required";
            }
            else if (password.length < 6) {
                newErrors.password = "Password must be at least 6 characters";
            }

        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const capitalizeName = (value) => {
        return value
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const handleSave = async () => {

        if (!validate()) return;

        try {

            if (editingUser) {

                await AdminUserService.updateUser(editingUser.id, {
                    name,
                    email,
                    role
                });

            } else {

                await AdminUserService.createUser({
                    name,
                    email,
                    password,
                    role
                });

            }

            setShowModal(false);
            loadUsers();

        } catch (err) {

            const message =
                err.response?.data?.error?.message ||
                err.response?.data ||
                err.message ||
                "Something went wrong";

            alert(message);

        }

    };

    const handleDelete = async (id) => {

        if (!window.confirm("Delete this admin user?")) return;

        try {

            await AdminUserService.deleteUser(id);
            loadUsers();

        } catch (err) {

            const message =
                err.response?.data?.error?.message ||
                err.response?.data ||
                err.message ||
                "Something went wrong";

            alert(message);

        }

    };

    return (

        <Container className="mt-5">

            <Row className="align-items-center mb-4">

                <Col md={6}>
                    <h3>Admin Users</h3>
                </Col>

                <Col md={6} className="text-end">

                    <Button
                        variant="secondary"
                        className="me-2"
                        onClick={() => navigate("/dashboard")}
                    >
                        Home
                    </Button>

                    <Button
                        variant="danger"
                        onClick={handleLogout}
                    >
                        Logout
                    </Button>

                </Col>

            </Row>

            <Row className="mb-3">

                <Col className="text-end">

                    <Button
                        variant="primary"
                        onClick={handleAddAdmin}
                    >
                        + Add Admin
                    </Button>

                </Col>

            </Row>

            <Table bordered hover responsive className="align-middle">

                <thead>

                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th style={{ width: "160px" }}>Actions</th>
                    </tr>

                </thead>

                <tbody>

                    {users.map((u, i) => (

                        <tr key={u.id}>
                            <td>{i + 1}</td>
                            <td>{u.name}</td>
                            <td>{u.email}</td>
                            <td>{u.role}</td>
                            <td>

                                <Button
                                    size="sm"
                                    variant="outline-primary"
                                    className="me-2"
                                    onClick={() => openEdit(u)}
                                >
                                    Edit
                                </Button>

                                {adminUser?.id !== u.id && (

                                    <Button
                                        size="sm"
                                        variant="outline-danger"
                                        onClick={() => handleDelete(u.id)}
                                    >
                                        Delete
                                    </Button>

                                )}

                            </td>
                        </tr>

                    ))}

                </tbody>

            </Table>


            <Modal show={showModal} onHide={() => setShowModal(false)}>

                <Modal.Header closeButton>
                    <Modal.Title>
                        {editingUser ? "Edit Admin" : "Add Admin"}
                    </Modal.Title>
                </Modal.Header>

                <Form onSubmit={(e) => {
                    e.preventDefault();
                    handleSave();
                }}>
                    <Modal.Body>

                        <Form.Group className="mb-3">
                            <Form.Label>Name <span style={{ color: "red" }}>*</span></Form.Label>
                            <Form.Control
                                value={name}
                                onChange={(e) => setName(capitalizeName(e.target.value))}
                                isInvalid={!!errors.name}
                                required
                            />
                            {errors.name && (
                                <div className="text-danger small">{errors.name}</div>
                            )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Email <span style={{ color: "red" }}>*</span></Form.Label>
                            <Form.Control
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                isInvalid={!!errors.email}
                                required
                            />
                            {errors.email && (
                                <div className="text-danger small">{errors.email}</div>
                            )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Role <span style={{ color: "red" }}>*</span></Form.Label>

                            <Form.Select
                                value={role}
                                onChange={(e) => setRole(e.target.value)}
                                isInvalid={!!errors.role}
                                required
                            >

                                <option value="Admin">Admin</option>
                                <option value="SuperAdmin">SuperAdmin</option>

                            </Form.Select>
                            {errors.role && (
                                <div className="text-danger small">{errors.role}</div>
                            )}
                        </Form.Group>

                        {!editingUser && (
                            <Form.Group>
                                <Form.Label>Password <span style={{ color: "red" }}>*</span></Form.Label>

                                <div style={{ position: "relative" }}>

                                    <Form.Control
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        style={{ paddingRight: "40px" }}
                                        isInvalid={!!errors.password}
                                        required
                                    />

                                    <span
                                        onClick={() => setShowPassword(!showPassword)}
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "#666"
                                        }}
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>

                                </div>
                                {errors.password && (
                                    <div className="text-danger small">{errors.password}</div>
                                )}
                            </Form.Group>
                        )}

                    </Modal.Body>

                    <Modal.Footer>

                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>

                        <Button
                            type="submit"
                            disabled={!name || !email || (!editingUser && !password)}>
                            Save
                        </Button>

                    </Modal.Footer>
                </Form>
            </Modal>

        </Container>

    );

}

export default AdminUsers;